module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-tabs/index.js
// module id = 1766
// module chunks = 0